import { Component } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { DocumentFormBase } from '../document-form.base';
import { dateValiditePjErrors } from '@lib/validators/date-validition-pj-errors-validators';
import { OuiDatePicker, OuiValidationError } from 'omnium-ui/form-field';
import moment from 'moment';

@Component({
  selector: 'app-document-form-att-vig',
  standalone: true,
  imports: [OuiDatePicker],
  templateUrl: './document-form-att-vig.component.html',
  styleUrl: './document-form-att-vig.component.scss',
})
export class DocumentFormAttVigComponent extends DocumentFormBase<AttVigForm> {
  readonly dateValidationErrors: OuiValidationError[] = dateValiditePjErrors();

  override createForm(fb: NonNullableFormBuilder) {
    return createAttVigForm(fb);
  }

  setDateFinDeValidite(newDate: moment.Moment | string | null) {
    if (newDate != null && typeof newDate != 'string') {
      const dateFinAttVig = moment(newDate).add(6, 'months').toDate();
      const newDateFin = newDate ? dateFinAttVig : undefined;

      this.form.get('dateFinValidite')?.setValue(newDateFin);
    }
  }
}

export function createAttVigForm(fb: NonNullableFormBuilder) {
  return fb.group({
    dateDebutValidite: fb.control<Date | undefined>(undefined, [Validators.required]),
    dateFinValidite: fb.control<Date | undefined>(undefined),
  });
}

export type AttVigForm = ReturnType<typeof createAttVigForm>;
export type AttVigFormValue = AttVigForm['value'];
